// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"51d5fbd0","178":"ec7f24dd","256":"1747dcc2","405":"fdc7a683","413":"5e09190e","692":"5867eefa","825":"5867eefa","906":"d23ec04e","971":"c952ee48"}[chunkId] + ".chunk.css";
};